<template>
  <v-row class="">
    <div class="flow-line">
      <div class="pt-8 flow-line-inside">&nbsp;</div>
    </div>
    <v-card outlined class="mx-auto py-1 px-8" width="95%" elevation="1">
      <v-row class="">
        <v-col cols="11" class="pt-0 px-0 mx-0"
          ><v-card-title>Voicemail</v-card-title></v-col
        >
        <v-col cols="1" class="px-0"></v-col>
        <v-col cols="12">
          <v-radio-group
            :disabled="PreviewMode"
            v-model="isTTS"
            row
            dense
            @change="updateRecordedMessageType"
          >
            <v-radio label="Text to Speech" :value="true"></v-radio>
            <v-radio label="Upload Audio File" :value="false"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col
          cols="12"
          class="my-0 py-0"
          v-if="recordedMessageType == 'audiofile'"
        >
          <v-sheet>
            <v-file-input
              :disabled="PreviewMode"
              :accept="acceptAudioFormats"
              label="Audio File for Voicemail Greeting"
              hint="Upload a MP3 or WAV file"
              persistent-hint
              dense
              aria-required="Voicemail greeting text is required"
              required
              :rules="[rules.required]"
              @change="onAudioUrlChanged"
              @click:clear="audioUrl = ''"
              outlined
            ></v-file-input>
            <v-lazy>
              <audio
                v-if="audioUrl"
                controls
                :src="`${recordingUrl}`"
                @play="setPlayerStatus('play')"
                @pause="setPlayerStatus('pause')"
                @ended="setPlayerStatus('ended')"
                class="recording-controls"
              ></audio>
            </v-lazy>
          </v-sheet>
        </v-col>
        <v-col
          cols="12"
          class="my-0 py-0"
          v-if="recordedMessageType == 'tts'"
        >
          <v-textarea
            :disabled="PreviewMode"
            label="Text to Speech Greeting"
            v-model="ttsText"
            @input="onUpdateAnything"
            class="py-1"
            dense
            auto-grow
            rows="2"
            aria-required="Greeting text is required"
            required
            :rules="[rules.required]"
            outlined
          ></v-textarea>
          <v-lazy>
            <audio
              v-if="ttsAudioUrl"
              controls
              :src="`${recordingUrl}`"
              @play="setPlayerStatus('play')"
              @pause="setPlayerStatus('pause')"
              @ended="setPlayerStatus('ended')"
              class="recording-controls"
            ></audio>
          </v-lazy>
        </v-col>
        <v-col class="mt-5"
          >We will play a recording tone so people know when to leave their
          message.</v-col
        >
        <v-col cols="12">
          <v-checkbox
            v-model="transcribeRecording"
            @change="onUpdateAnything"
            :label="
              transcribeRecording
                ? 'Transcribe Recordings'
                : 'Don\'t Transcribe Recordings'
            "
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-btn
        :disabled="PreviewMode"
        text
        icon
        color="error"
        @click="onRemoveMe"
        class="float-right"
      >
        Remove
      </v-btn>
    </v-card>
  </v-row>
</template>

<script>
import { VALIDATION_RULES } from "../../../helpers/ValidationRules";
import hashCode from "../../../helpers/hashCode";
import { API_BASE_URL } from "../../../globalVars";
import axios from "axios";

export default {
  name: "CallFlowVoicemail",
  components: {},
  props: {
    order: {
      type: Number,
      required: true
    },
    updateCallback: {
      type: Function,
      required: false
    },
    onRemove: {
      type: Function,
      required: true
    },
    flowList: {
      type: Array,
      required: true
    },
    config: {
      type: Object,
      required: true
    },
    PreviewMode: {
      type: Boolean,
      required: true
    }
  },
  data: function() {
    return {
      rules: VALIDATION_RULES,

      acceptAudioFormats: "audio/mp3,audio/mpeg,audio/x-wav",
      playerStatus: "new",

      isTTS: true,
      recordedMessageType: "tts",
      ttsText: "",
      audioUrl: "",

      ttsAudioUrl: null,
      transcribeRecording: true,

      recordingUrl: null
    };
  },
  created() {
    if (
      this.order != null &&
      this.flowList.length > 0 &&
      this.flowList[this.order] &&
      this.flowList[this.order].recordedMessageType
    ) {
      const tempData = Object.assign({}, this.flowList[this.order]);
      this.recordedMessageType = tempData.recordedMessageType;
      this.transcribeRecording = tempData.transcribeRecording;
      this.isTTS = this.recordedMessageType == "tts";
      this.ttsText = tempData.ttsText;
      this.audioUrl = tempData.audioUrl;
      this.updateRecordingUrl(this.audioUrl);
      if (this.recordedMessageType == "tts") {
        const hashCodeFromText = hashCode(this.ttsText);
        this.ttsAudioUrl = `telephony/call-flow/${tempData.uid}/${hashCodeFromText}.mp3`;
        this.updateRecordingUrl(this.ttsAudioUrl);
      }
    }
  },
  computed: {
    account() {
      return this.$store.getters["entities/accounts/query"]()
        .withAllRecursive(1)
        .first();
    }
  },
  methods: {
    updateRecordedMessageType() {
      if (this.isTTS) {
        this.recordedMessageType = "tts";
      } else {
        this.recordedMessageType = "audiofile";
      }
      this.recordingUrl = null;
      this.onUpdateAnything();
    },
    onAudioUrlChanged(args) {
      let recordingFile = args;
      this.uploadRecordingFile({ type: "call-flow", recordingFile });
    },
    uploadRecordingFile({ type, recordingFile }) {
      if (!recordingFile) {
        return;
      }
      // do the upload
      let vueThis = this;
      let formData = new FormData();
      formData.append("file", recordingFile);
      axios({
        method: "get",
        url:
          API_BASE_URL +
          `/file-upload/telecom-recording?type=${type}&contenttype=${
            recordingFile.type
          }&name=${encodeURIComponent(recordingFile.name)}&uid=${
            vueThis.config.uid
          }`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      })
        .then(response => {
          axios
            .put(response.data.url, recordingFile, {
              headers: {
                "Content-Type": recordingFile.type
              }
            })
            .then(function(putResponse) {
              const url = putResponse.config.url.split("?")[0].split("/");
              const newValue = [url[6], url[7], url[8], url[9]].join("/");
              vueThis.audioUrl = newValue;
              vueThis.updateRecordingUrl(newValue);
              vueThis.onUpdateAnything();
            })
            .catch(function(error) {
              console.error("Unable to upload file ", error);
            });
        })
        .catch(error => {
          console.error("Unable to get an signed upload URL", error);
        });
    },
    updateRecordingUrl(path) {
      if (!path) return;
      let vueThis = this;
      const externalId = this.account.externalId;
      axios({
        method: "get",
        url:
          API_BASE_URL +
          `/account?do=file-url&externalId=${externalId}&path=account/${externalId}/${path}`,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`
        }
      }).then(response => {
        vueThis.recordingUrl =
          response && response.data ? response.data.url : null;
      });
    },
    setPlayerStatus(status) {
      this.playerStatus = status;
    },
    onRemoveMe() {
      this.onRemove(this.config.uid);
    },
    onUpdateAnything() {
      const newConfig = Object.assign({}, this.config);
      newConfig.order = this.order;
      newConfig.recordedMessageType = this.recordedMessageType;
      newConfig.transcribeRecording = this.transcribeRecording;
      newConfig.ttsText = this.ttsText;
      newConfig.audioUrl = this.audioUrl;
      // this.updateRecordingUrl(this.audioUrl);
      this.updateCallback(this.order, newConfig);
    }
  },
  watch: {
    ttsText(newVal, oldVal) {
      if (oldVal != "" && oldVal != newVal) {
        this.ttsAudioUrl = null;
      }
    }
  }
};
</script>

<style scoped lang="stylus">
.call-flow-icon {
  color: #1976d2 !important;
  caret-color: #1976d2 !important;
  font-weight: 400;
}
.flow-line {
  height: 3rem;
  width: 100%;
}
.flow-line-inside {
  height: 3rem;
  width: 50%;
  border-right: 1px solid #cccccc;
}
.setup-settings-menu {
  background: white;
}
</style>
